﻿import packageJson from '../../../package.json';

export default function Footer() {
  return (
    <footer className="bg-dark text-light py-3 mt-auto">
      <div className="container d-flex justify-content-between align-items-center">
        <small>&copy; {new Date().getFullYear()} LMeet - Partner Tecnologico{' '}
          <a href="https://www.tabatatech.it" target="_blank" rel="noreferrer" className="text-light">TABATA</a>
        </small>
        <small className="text-muted">v{packageJson.version}</small>
      </div>
    </footer>
  );
}
